import { User } from "../user/user.model";
import { BaseRate } from "./rate-base.model";
import { Client } from "../client/client.model";
import { Rate } from "./rate-type";
import { Carrier } from "../carrier/carrier.model";
import { WeightBracketName } from "../shared/weight-bracket/weight-bracket-name.type.const";
import { RatePickupDeliveryRoute } from "./rate-flat-route-list/rate-ltl-pickup-delivery-route.model";
import { Company } from "app/company/company.model";

export class LtlPickupDeliveryRate extends BaseRate {
  constructor(
    protected id: number,
    protected name: string,
    protected discriminator: string,
    protected rangeType: string,
    protected createdBy?: User,
    protected updatedBy?: User,
    protected createdAt?: Date,
    protected updatedAt?: Date,
    protected type?: string,
    protected source?: string,
    protected status?: string,
    protected internalNote?: string,
    protected externalNote?: string,
    protected pmNote?: string,
    protected comment?: string,
    protected deepLink?: string,
    protected carrier?: Carrier,
    protected validity?: Date[],
    protected contractNumber?: string,
    protected availableOnline?: boolean,
    protected restrictedClients?: Client[],
    protected restrictedUsers?: User[],
    protected rootParent?: Rate,
    protected flatRateRoutes?: RatePickupDeliveryRoute[],
    public currency?: string,
    public ldm?: number,
    public cbm?: number,
    public ldmThreshold?: number,
    public ldmWidthThreshold?: number,
    public ldmHeightThreshold?: number,
    public ldmLengthThreshold?: number,
    public lengthThreshold?: number,
    public lengthExtraCharge?: number,
    public lengthPercentageExtraCharge?: number,
    public lengthValueExtraCharge?: number,
    public minWeight?: number,
    public maxWeight?: number,
    public minTaxWeight?: number,
    public maxTaxWeight?: number,
    public maxLength?: number,
    public maxHeight?: number,
    public maxWidth?: number,
    public maxLW?: number,
    public maxLWH?: number,
    public minLength?: number,
    public minHeight?: number,
    public minWidth?: number,
    public minLW?: number,
    public minLWH?: number,
    public terminalType?: string,
    public direction?: string,
    public availableWeightBrackets?: WeightBracketName[],
    public hiddenMarkup?: number,
    public companies?: Company[],
  ) {
    super(
      id,
      name,
      discriminator,
      createdBy,
      updatedBy,
      createdAt,
      updatedAt,
      type,
      source,
      status,
      internalNote,
      externalNote,
      pmNote,
      comment,
      deepLink,
      carrier,
      validity,
      contractNumber,
      restrictedClients,
      restrictedUsers,
      rootParent,
    );
  }

  public getAvailableOnline(): boolean {
    return this.availableOnline;
  }

  public setAvailableOnline(availableOnline: boolean) {
    this.availableOnline = availableOnline;
  }

  public getRangeType() {
    return this.rangeType;
  }

  public getCurrency() {
    return this.currency;
  }

  public setCurrency(param: string): void {
    this.currency = param;
  }

  public getFlatRateRoutes() {
    return this.flatRateRoutes;
  }

  public setFlatRateRoutes(flatRateRoutes): void {
    this.flatRateRoutes = flatRateRoutes;
  }

  public getCompanies(): Company[] {
    return this.companies;
  }

  public get companyName(): string {
    if (this.companies && this.companies.length > 0) {
      return this.companies.map((company) => company.name).join(", ");
    }

    return "";
  }

  public setCompanies(param: Company[]): void {
    this.companies = param;
  }

  public isValid(): boolean {
    return !!this.name && !!this.carrier && !!this.validity;
  }
}
